<!-- =========================================================================================
    File Name: DeviceIdent.vue
    Description: Изменение серийного номера
========================================================================================== -->


<template>
    <vs-prompt
        title="Изменение серийного номера"
        accept-text= "Сохранить"
        cancel-text = "Закрыть"
        button-cancel = "border"
        @accept="submitAction"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input v-validate="'required'" name="ident" class="w-full mb-4 mt-5" placeholder="Cерийный номер" v-model="deviceLocal.ident" />
                        <vs-select v-model="deviceLocal.type" label="Тип устройства" class="w-50">
                            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in deviceTypeList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>
</template>

<script>
import moduleDevice          from '@/store/device/moduleDevice.js'

export default {
    props: {
        displayPrompt: {
            type: Boolean,
            required: true,
        },
        device: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            deviceTypeList: moduleDevice.deviceTypeList,
            deviceLocal: Object.assign({}, this.device),
        }
    },
    computed: {
        activePrompt: {
            get() {
                return this.displayPrompt
            },
            set(value) {
                this.$emit('hidePromptIdent', value)
            }
        },
        validateForm() {
            return !this.errors.any()
        }
    },
    methods: {
        submitAction() {
            this.$store.dispatch("device/updateDevice", {did: this.deviceLocal.did, ident: this.deviceLocal.ident, type: this.deviceLocal.type})
        }

    },
}
</script>

<style lang="scss">

    .con-select {
        width: 350px;
    }

</style>